import { EventEmitter, Injectable } from "@angular/core";
import { ApiException, API_BASE_URL, AuthenticateModel, AuthenticateResultModel, CreateOrEditAttributeDto, CreateOrEditBillAndPlanBillDto, CreateOrEditBillDto, CreateOrEditBranchDto, Plans, CreateOrEditCondolenceMessageDto, CreateOrEditContactAndDependentFormsDto, CreateOrEditContactDto, CreateOrEditContactOutputDto, CreateOrEditPlanBillDto, CreateOrEditSlaughterAgentDto, CreatePaymentByAdminInput, GetBillForEditOutput, GetBrachAndAddressForEditOutput, GetCondolenceMessageForEditOutput, GetPlanBillForEditOutput, PasswordInputDto, Property, VerifyCodeForRestPassInputDto, GetConsumesAndSourceGroupBySourceForEditOutput, NotApprovedPayInput, ExpirePlanBillInput, CreateOrEditPlanConstAndBannerAndPlansDto, CreateOrEditAreaDto, GetFamilySupportOrganizationForViewDto, GetFamilyForEditOutput, GetFamilyMemberForViewDto, GetAddressForViewDto, GetDocumentForViewDto, GetFamilyIncomeOutcomeForViewDto, GetAttributeForFamilyDto, PagedResultDtoOfGetFamilyMemberForViewDto, PagedResultDtoOfGetAddressForViewDto, PagedResultDtoOfGetDocumentForViewDto, PagedResultDtoOfGetTagForViewDto, PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto, PagedResultDtoOfGetAttributeForFamilyDto, CommodityDto, VerifyPhoneNumberInput, ActionResult, CreatePaymentByAdminOutput, VerifyEmailInput, FamilySupportiveOrganizationsLookupTableDto, CreateOrEditAttributeValueDto } from "./service-proxies";

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Inject, Optional, } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import * as moment from 'moment';


@Injectable({
    providedIn: 'root'
})
export class CustomService {
    attribute: EventEmitter<CreateOrEditAttributeDto> = new EventEmitter();
    attributes: EventEmitter<CreateOrEditAttributeDto[]> = new EventEmitter();
    billForCeremony: EventEmitter<any> = new EventEmitter<any>();
    newContact: CreateOrEditContactDto = new CreateOrEditContactDto();
    newContactType: ContactType = 1;
    filterTextForNewContact: string = "";
    filterTextForNewContactClose: string = "";
    billForNewContact: GetBillForEditOutput = new GetBillForEditOutput();
    billAttrSourcesForNewContact = [];
    branchForNewContact: GetBrachAndAddressForEditOutput = new GetBrachAndAddressForEditOutput();
    planBillForNewContact: GetPlanBillForEditOutput = new GetPlanBillForEditOutput();
    condolenceMessageForNewContact: GetCondolenceMessageForEditOutput = new GetCondolenceMessageForEditOutput();
    slaughterAgentForNewContact: CreateOrEditSlaughterAgentDto = new CreateOrEditSlaughterAgentDto();
    slaughterAgentPropertyForNewContact: Property[] = [];

    familyForNewContact: GetFamilyForEditOutput = new GetFamilyForEditOutput;
    familySupportOrganizationsForNewContact: FamilySupportiveOrganizationsLookupTableDto[] = [];
    familyMembersForNewContact: PagedResultDtoOfGetFamilyMemberForViewDto = new PagedResultDtoOfGetFamilyMemberForViewDto();
    familyAddressesForNewContact: PagedResultDtoOfGetAddressForViewDto = new PagedResultDtoOfGetAddressForViewDto();
    familyDocumentsForNewContact: PagedResultDtoOfGetDocumentForViewDto = new PagedResultDtoOfGetDocumentForViewDto();
    familyTagsForNewContact: PagedResultDtoOfGetTagForViewDto = new PagedResultDtoOfGetTagForViewDto();
    familyIncomeOutcomesForNewContact: PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto = new PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto();
    familyAttributeForNewContact: PagedResultDtoOfGetAttributeForFamilyDto = new PagedResultDtoOfGetAttributeForFamilyDto();
    familyMemberForNewcontact: GetFamilyMemberForViewDto = new GetFamilyMemberForViewDto();
    editFamilyMemberIndexForNewContact: number = null
}

export enum ContactType {
    Default = 0,
    Contact = 1,
    Agent = 2,
    Connector = 3
}

export enum ReturnPcPosCode {
    RET_OK = 100,
    ERR_PC_INVALID_REC_SIZE = 101,
    ERR_POS_INVALID_DATA = 102,
    ERR_PC_INVALID_REC_PROCESS_CODE = 103,
    ERR_PC_INVALID_AMOUNT = 104,
    ERR_PC_INVALID_INPUT_PAYERID = 105,
    ERR_PC_INVALID_INPUT_TIMEOUT = 106,
    ERR_PC_PORT_TIMEOUT_FOR_REC = 107,
    ERR_POS_RESPONSE_RECEIVED_TOO_LATE = 108,
    ERR_POS_FAILED_TRANSACTION = 109,
    ERR_POS_PRINTER = 110,
    ERR_POS_COMMUNICATION = 111,
    ERR_POS_TO_SEND_TRANSACTION = 112,
    ERR_PC_INVALID_INPUT_PORTNAME = 113,
    ERR_POS_USER_ABORT = 114,
    ERR_PC_INVALID_INPUT_BILLID = 115,
    ERR_PC_INVALID_INPUT_PAYID = 116,
    ERR_PC_PORT_OPEN_FAILED = 117,
    ERR_PC_PORT_ACCESS_FAILED = 118,
    ERR_PC_INVALID_PORT_STATE = 119,
    ERR_PC_INVALID_PORT_PARAMETERS = 120,
    ERR_PC_INVALID_PORT_NAME = 121,
    ERR_PC_NULL_STR_TO_WRITE_IN_PORT = 122,
    ERR_PC_PORT_TIMEOUT_FOR_SEND = 123,
    ERR_POS_CARD_SWIPE_FAILED = 124,
    ERR_PC_INVALID_INPUT_ACCOUNTID = 125,
    ERR_POS_INVALID_INPUT_ACCOUNTID = 126,
    ERR_POS_INVALID_INPUT_PAYERID = 0x7F,
    ERR_POS_INVALID_INPUT_AMOUNT = 0x80,
    ERR_POS_INVALID_INPUT_REFRENCE_NUMBER = 129,
    ERR_POS_INVALID_INPUT_BILL_ID = 130,
    ERR_POS_INVALID_INPUT_PAYMENT_ID = 131,
    ERR_POS_INVALID_INPUT_ADDITIONALDATA = 132,
    ERR_POS_INVALID_MULTI_PAYMENT_AMOUNT = 133,
    ERR_POS_UNCONFIRM_REC_DATA = 134,
    ERR_PC_INVALID_INPUT_MULTI_PAYMENT_REQUEST_LIST = 161,
    ERR_PC_INVALID_INPUT_MULTI_PAYMENT_AMOUNT = 162,
    ERR_PC_INVALID_INPUT_REFERENCE_NUMBER = 163,
    ERR_POS_PC_CRCERROR_INVALID_DATA = 164,
    ERR_PC_INVALID_POSPC_COMMUNICATION_TYPE = 165,
    ERR_PC_INVALID_INPUT_TCP_SOCKET_PORT = 166,
    ERR_PC_INVALID_INPUT_TCP_SOCKET_RECEIVED_TIMEOUT = 167,
    ERR_PC_TCP_SOCKET_FAILED = 168,
    ERR_PC_TCP_SOCKET_SEND_MSG_FAILED = 169,
    ERR_PC_TCP_SOCKET_RECEIVED_MSG_FAILED = 170,
    ERR_PC_INVALID_INPUT_MERCHANT_MESSAGE = 171,
    ERR_PC_PREPARE_TLV_MSG_FAILED = 172,
    ERR_PC_PORT_EXCEPTION_FOR_REC = 173,
    ERR_PC_NULL_STR_IN_READ_PORT = 174,
    ERR_PC_CALCULATE_CRC_ERROR = 175,
    ERR_PC_INVALID_INPUT_MERCHANT_FIELD = 176,
    RET_OK_RequestID = 177,
    RET_POS_Busy = 178,
    ERR_POS_PC_OTHER = 200
}

export enum ReturnPcSepPosCode {
    تراکنش_با_موفقیا_انجام_پذیرفت = 0,
    کارت_کشیده_شد = 1,
    مبلغ_تراکنش_نمیتواند_از_حداقل_مبلغ_کوچکتر_باشد = 2,
    عدم_ارتباط_با_دستگاه = 3,
    اطلاعات_نامعتبر = 4,
    صفر_ریال_بدهی = 5,
    خطا_در_دریافت_اطلاعات = 6,
    عدم_دسترسی_به_این_عملیات = 7,
    تراکنش_یافت_نشد = 8,
    ترمینال_نامعتبر = 9,
    خطا_در_پاسخ = 10,
    تراکنش_نامعتبر = 12,
    مبلغ_نا_معتبر = 79,
    مبلغ_نامعتبر = 13,
    خطا_در_مقداردهی = 14,
    پاسخ_نامعتبر = 20,
    خطا_در_تراکنش = 26,
    این_قبض_قبلا_پرداخت_شده_است = 27,
    غیرقابل_پرداخت = 28,
    خطا_در_قالب_اطلاعات = 30,
    تاریخ_انقضای_کارت_سپری_شده_است = 33,
    اخطار_امنیتی = 34,
    اخطار__امنیتی = 63,
    اخطار_امنیتی_ = 43,
    تعداد_دفعات_ورود_رمز_غلط_بیش_از_حدمجاز_است = 38,
    موجودی_کافی_نمیباشد = 51,
    رمز_کارت_نامعتبر = 55,
    انجام_تراکنش_مربوطه_توسط_دارنده_ی_کارت_مجاز_نمیباشد = 57,
    انجام_تراکنش_مربوطه_توسط_پایانه_انجام_دهنده_مجاز_نمیباشد = 58,
    مبلغ_تراکنش_بیش_از_حد_مجاز_میباشد = 61,
    عدم_دریافت_پاسخ_در_زمان_مناسب = 68,
    تعداد_دفعات_ورود_رمزغلط_بیش_از_حدمجاز_است = 75,
    تعداد_دفعات_ورود_رمزغلط_بیش_از_حدمجاز = 69,
    کارت_غیرفعال_میباشد = 78,
    عدم_پاسخ_از_سوی_صادرکننده_کارت = 80,
    عدم_پاسخ_از_سوی_صادر_کننده_کارت = 84,
    عدم_دریافت_پاسخ_از_سوی_صادرکننده_کارت = 91,
    مبالغ_متفاوت = 92,
    خطای_نامشخص = 96,
    عدم_ارتباط_با_مرکز = 97,
    لغو_عملیات_توسط_کاربر = 98,
    عدم_دریافت_پاسخ_در_زمان_مناسب_در_کارتخوان = 99
}
export class PcToPosOutputDto implements IPcToPosOutputDto {
    serrialNo!: string | undefined;
    trackingNo!: string | undefined;
    pan!: string | undefined;
    date!: string | undefined;
    time!: string | undefined;

    constructor(data?: IPcToPosOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serrialNo = data["serrialNo"];
            this.trackingNo = data["trackingNo"];
            this.pan = data["pan"];
            this.date = data["date"];
            this.time = data["time"];
        }
    }

    static fromJS(data: any): PcToPosOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PcToPosOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serrialNo"] = this.serrialNo;
        data["trackingNo"] = this.trackingNo;
        data["pan"] = this.pan;
        data["date"] = this.date;
        data["time"] = this.time;
        return data;
    }
}

export interface IPcToPosOutputDto {
    serrialNo: string | undefined;
    trackingNo: string | undefined;
    pan: string | undefined;
    date: string | undefined;
    time: string | undefined;
}

export class Basket {
    commodity: CommodityDto;
    count: number;
    isRationOrPayment: boolean;
}

export class BasketTab {
    commodityFilter: string = '';
    entityFilter: number;
    branchRefFilter: number;
    identityCodeFilter: string = '';
    clientFirstName = '';
    clientId: number;
    familyName = '';
    familyId: number;
    isPublic = false;
    profilePicture = '';
    basket: Basket[] = [];
    totalPrice: number = 0;
    description: string;
    creditAmount: number;
    // primengTableHelper: PrimengTableHelper;
    // @ViewChild('dataTable', { static: true }) dataTable: Table;
    // @ViewChild('paginator', { static: true }) paginator: Paginator;
}

export enum FlowerCrownColors {
    Red = 0,
    Blue = 1,
    Black = 2,
    White = 3,
    Green = 4,
    Brown = 5
}

export enum WizardProcess {
    Deceased = 1,
    Ceremony = 2,
    Service = 3,
    Summary = 4,
    Orphan = 5,
    FlowerCrown = 6,
    Appreciation = 7,
    Charity = 8,
    MoneyBoxDetails = 9,
    SacrificeDetails = 10,
    CharityForDeceased = 11
}

export class CreatePlanFromBill {
    planType: Plans;
    contactRef: number | undefined;
    contactName: string;
}

export class Utils {
    constructor() { }

    groupBy<T, K>(list: T[], getKey: (item: T) => K) {
        const map = new Map<K, T[]>();
        list.forEach((item) => {
            const key = getKey(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return Array.from(map.values());
    }
}
export interface IActionResult {
    statusCode: number;
    message: string;
}
interface TagData {
    value: string;
    [key: string]: any;
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {



    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    resetPasswordBySendSMSCode(body: PasswordInputDto | undefined) {

        return this.http.post(`${this.baseUrl}/api/TokenAuth/ResetPasswordBySendSMSCode`, body);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifySmsCodeForRestPass(body: VerifyCodeForRestPassInputDto | undefined) {
        return this.http.post(`${this.baseUrl}/api/TokenAuth/VerifySmsCodeForRestPass`, body);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditContactAndDependentForms(body: CreateOrEditContactAndDependentFormsDto | undefined): Observable<CreateOrEditContactOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/CreateOrEditContactAndDependentForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditContactAndDependentForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditContactAndDependentForms(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditContactOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditContactOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditContactAndDependentForms(response: HttpResponseBase): Observable<CreateOrEditContactOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {

            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditContactOutputDto>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */

    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {

            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {

            if (response_ instanceof HttpResponseBase) {

                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else {
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
            }

        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AuthenticateResultModel.fromJS(resultData200);

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }



    /**
    * @param sendSMSForRegister (optional) 
    * @return Success
    */
    sendVerificationSmsCode(phoneNumber: string, sendSMSForRegister: boolean | undefined): Observable<ActionResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendVerificationSmsCode?";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined and cannot be null.");
        else
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (sendSMSForRegister === null)
            throw new Error("The parameter 'sendSMSForRegister' cannot be null.");
        else if (sendSMSForRegister !== undefined)
            url_ += "SendSMSForRegister=" + encodeURIComponent("" + sendSMSForRegister) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendVerificationSmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSmsCode(<any>response_);
                } catch (e) {
                    return <Observable<ActionResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActionResult>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationSmsCode(response: HttpResponseBase): Observable<ActionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActionResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<ActionResult>(<any>null);
    }


    /**
     * @param sendEmailForRegister (optional) 
     * @return Success
     */
    sendVerificationEmailCode(emailAddressTo: string, sendEmailForRegister: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendVerificationEmailCode?";
        if (emailAddressTo === undefined || emailAddressTo === null)
            throw new Error("The parameter 'emailAddressTo' must be defined and cannot be null.");
        else
            url_ += "EmailAddressTo=" + encodeURIComponent("" + emailAddressTo) + "&";
        if (sendEmailForRegister === null)
            throw new Error("The parameter 'sendEmailForRegister' cannot be null.");
        else if (sendEmailForRegister !== undefined)
            url_ += "SendEmailForRegister=" + encodeURIComponent("" + sendEmailForRegister) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendVerificationEmailCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationEmailCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationEmailCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }


    /**
    * @param body (optional) 
    * @return Success
    */
    verifyContactMobileNumber(body: VerifyPhoneNumberInput | undefined): Observable<ActionResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyContactMobileNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyContactMobileNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyContactMobileNumber(<any>response_);
                } catch (e) {
                    return <Observable<ActionResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActionResult>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyContactMobileNumber(response: HttpResponseBase): Observable<ActionResult> {

        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ActionResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<ActionResult>(<any>null);
    }


    /**
     * @param body (optional) 
     * @return Success
     */
    verifyContactEmail(body: VerifyEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyContactEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyContactEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyContactEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyContactEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}


function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}


@Injectable({
    providedIn: 'root'
})
export class PlanBillCostumService {

    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
      * @param body (optional) 
      * @return Success
      */
    cancelPlanBill(body: ExpirePlanBillInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/CancelPlanBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelPlanBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPlanBill(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPlanBill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {

                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PlanConstCostumService {

    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
         * @param body (optional) 
         * @return Success
         */
    createOrEditPlanConstAndBannerAndPlan(body: CreateOrEditPlanConstAndBannerAndPlansDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/CreateOrEditPlanConstAndBannerAndPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditPlanConstAndBannerAndPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditPlanConstAndBannerAndPlan(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditPlanConstAndBannerAndPlan(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BillCostumService {

    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
    * @param body (optional) 
    * @return Success
    */


    createOrEditBillAndPlanBill(body: CreateOrEditBillAndPlanBillDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditBillAndPlanBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditBillAndPlanBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBillAndPlanBill(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBillAndPlanBill(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {

                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);

            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }



    /**
     * @param billId (optional) 
     * @return Success
     */
    sendCartLinkMessage(billId: number | undefined): Observable<void> {

        let url_ = this.baseUrl + "/api/services/app/Bills/SendCartLinkMessage?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendCartLinkMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCartLinkMessage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendCartLinkMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }



    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBillDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }


    // /**
    //  * @param body (optional) 
    //  * @return Success
    //  */
    // pcToPos(body: PcToPosInput | undefined): Observable<PcToPosOutputDto> {
    //     let url_ = this.baseUrl + "/api/services/app/Payments/PcToPos";
    //     url_ = url_.replace(/[?&]$/, "");

    //     const content_ = JSON.stringify(body);

    //     let options_: any = {
    //         body: content_,
    //         observe: "response",
    //         responseType: "blob",
    //         headers: new HttpHeaders({
    //             "Content-Type": "application/json-patch+json",
    //             "Accept": "text/plain"
    //         })
    //     };

    //     return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
    //         return this.processPcToPos(response_);
    //     })).pipe(_observableCatch((response_: any) => {
    //         if (response_ instanceof HttpResponseBase) {
    //             try {
    //                 return this.processPcToPos(<any>response_);
    //             } catch (e) {
    //                 return <Observable<PcToPosOutputDto>><any>_observableThrow(e);
    //             }
    //         } else
    //             return <Observable<PcToPosOutputDto>><any>_observableThrow(response_);
    //     }));
    // }

    // protected processPcToPos(response: HttpResponseBase): Observable<PcToPosOutputDto> {
    //     const status = response.status;
    //     const responseBlob =
    //         response instanceof HttpResponse ? response.body :
    //             (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    //     let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    //     if (status === 200) {
    //         return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
    //             let result200: any = null;
    //             let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
    //             result200 = PcToPosOutputDto.fromJS(resultData200);
    //             return _observableOf(result200);
    //         }));
    //     } else if (status !== 200 && status !== 204) {
    //         return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
    //             return throwException(_responseText, status, _responseText, _headers);
    //         }));
    //     }
    //     return _observableOf<PcToPosOutputDto>(<any>null);
    // }

    /**
         * @param body (optional) 
         * @return Success
         */
    pcToPosWebService(body: { "ServiceCode": string, "Amount": string, "PayerId": string, "PcID": string }, ip: string, port: string) {
        console.log('body', body);
        // return this.http.post(`https://${ip}:${port}/bpmpospc/service`, body);
        return this.http.post(`http://localhost:${port}/bpmpospc/service`, body);
    }
    /**
            * @param body (optional) 
            * @return Success
            */
    bpInquery(body) {
        return this.http.post(`${this.baseUrl}/Payment/BpInqueryRequst`, body)
    }

    /**
     * @param payId (optional) 
     * @param accountingTrackingNo (optional) 
     * @return Success
     */
    approvePay(payId: number | undefined, accountingTrackingNo: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/ApprovePay?";
        if (payId === null)
            throw new Error("The parameter 'payId' cannot be null.");
        else if (payId !== undefined)
            url_ += "payId=" + encodeURIComponent("" + payId) + "&";
        if (accountingTrackingNo === null)
            throw new Error("The parameter 'accountingTrackingNo' cannot be null.");
        else if (accountingTrackingNo !== undefined)
            url_ += "accountingTrackingNo=" + encodeURIComponent("" + accountingTrackingNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processApprovePay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovePay(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApprovePay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notApprovePay(body: NotApprovedPayInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/NotApprovePay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processNotApprovePay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotApprovePay(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNotApprovePay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentByAdmin(body: CreatePaymentByAdminInput | undefined): Observable<CreatePaymentByAdminOutput> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/CreatePaymentByAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePaymentByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentByAdmin(<any>response_);
                } catch (e) {
                    return <Observable<CreatePaymentByAdminOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreatePaymentByAdminOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePaymentByAdmin(response: HttpResponseBase): Observable<CreatePaymentByAdminOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreatePaymentByAdminOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePaymentByAdminOutput>(<any>null);
    }


    /**
     * @param billIdInput (optional) 
     * @return Success
     */
    cancelPay(billIdInput: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/CancelPay?";
        if (billIdInput === null)
            throw new Error("The parameter 'billIdInput' cannot be null.");
        else if (billIdInput !== undefined)
            url_ += "billIdInput=" + encodeURIComponent("" + billIdInput) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPay(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConsumesAndSourceCostumService {

    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
    * @param body (optional) 
    * @return Success
    */
    createOrEditGroupBySource(body: GetConsumesAndSourceGroupBySourceForEditOutput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/CreateOrEditGroupBySource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditGroupBySource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditGroupBySource(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditGroupBySource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException(_responseText, status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }




}

export class PrintLabelInfo {
    date: moment.Moment;
    billsInfo: PrintBillInfo[];
}

export class PrintBillInfo {
    id: number;
    cards: CardValueInfo[];
}

export class CardValueInfo {
    propertyRef: number;
    value: string;
}

export class PrintPosterInfo {
    date: moment.Moment;
    bills: number[]
}